import { render } from "./TaxonomyNcbiSearch.vue?vue&type=template&id=05f3607c"
import script from "./TaxonomyNcbiSearch.vue?vue&type=script&lang=js"
export * from "./TaxonomyNcbiSearch.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__